/** Shared look of form controls (Input, Select). */
export const CONTROL_BASE =
  'rounded-lg border border-line-strong bg-surface px-3 transition-[border-color,box-shadow] ' +
  'placeholder:text-fg-muted focus:border-accent focus:shadow-[0_0_0_3px_var(--accent-wash)] focus:outline-none';

export const CONTROL_SIZES = {
  md: 'h-9 text-[13px]',
  lg: 'h-10 text-sm',
} as const;
